import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useStockApi } from './use-stock-api';

// Sort + dedup so callers passing the same SKUs in any order share one cache entry.
const normalizeSkus = (skus: string[] | null | undefined) =>
  skus ? Array.from(new Set(skus)).sort() : skus;

const QK_BATCH_FETCH_STOCK = (skus: string[] | null | undefined) =>
  ['stock', 'batch-fetch', normalizeSkus(skus)] as const;

// Nullable so callers can wire conditional state without breaking rules-of-hooks.
export function useBatchFetchStock(skus: string[] | null | undefined) {
  const { stockApi } = useStockApi();

  const stableSkus = useMemo(() => normalizeSkus(skus), [skus]);

  return useQuery({
    queryKey: QK_BATCH_FETCH_STOCK(stableSkus),
    queryFn: () => {
      if (!stableSkus?.length) {
        throw new Error('At least one SKU is required');
      }
      return stockApi.batchFetchStock({ skus: stableSkus });
    },
    enabled: !!stableSkus?.length,
  });
}
